import BigNumber from "bignumber.js";

export const BN_ZERO = new BigNumber(0);
export const BN_ONE = new BigNumber(1);

export const Paths = {
  Landing: {
    Index: "/",
  },
};

export const PUSH_NOTIFICATION_STORAGE_KEY = "push-notification-register-status";
export const REGISTERED = "REGISTERED";

export const LOGIN_URL = "https://a.ntrk2.com/78ff3799-7e76-4a44-b5ba-6f47865cb6ac";
export const REGISTER_URL = "https://a.ntrk2.com/f5508b11-5554-411e-8ad6-90cb46eca918";

export const LOGIN_URL_MAP = {};

export const REGISTER_URL_MAP = {};

export const FLOATING_BANNER_URL = "";

export const DOWNLOAD_URL = "https://ma268.loadprkw2a.com/download?openExternalBrowser=1&id=dir65y8mplfiiy8";

export * from "./codes";
export * from "./context";
